const basePath = "/images/src/components/Awards/images";

const images = {
  award0: { url: `${basePath}/award0.png`, width: 500, height: 150 },
  award1: { url: `${basePath}/award1.png`, width: 742, height: 500 },
  award2: { url: `${basePath}/award2.png`, width: 1080, height: 1080 },
  award3: { url: `${basePath}/award3.png`, width: 1080, height: 1080 },
  award4: { url: `${basePath}/award4.png`, width: 966, height: 486 },
  award5: { url: `${basePath}/award5.png`, width: 979, height: 398 },
  award6: { url: `${basePath}/award6.png`, width: 979, height: 398 },
  award7: { url: `${basePath}/award7.png`, width: 288, height: 242 },
  award8: { url: `${basePath}/award8.png`, width: 469, height: 474 },
};

const AWARDS = [
  {
    image: images.award0,
    title: "The National Cyber Awards UK 2023 - Innovation of the Year",
    maxWidth: 170,
  },
  {
    image: images.award1,
    title: "Go:Tech Awards 2024 - AI/Machine Learning",
    maxWidth: 170,
  },
  {
    image: images.award2,
    title: "BOLD Awards 2024 - Science",
    maxWidth: 100,
  },
  {
    image: images.award3,
    title: "BOLD Awards 2024 - SaaS",
    maxWidth: 100,
  },
  {
    image: images.award4,
    title:
      "Computing Security Awards 2025 - Security Software Solution of the Year",
    maxWidth: 170,
  },
  {
    image: images.award5,
    title: "British Security Awards 2025 - Best Use of Technology (Finalist)",
    maxWidth: 170,
  },
  {
    image: images.award6,
    title:
      "British Security Awards 2026 - Innovative Project of the Year (Highly Commended)",
    maxWidth: 170,
  },
  {
    image: images.award7,
    title: "Top 10 CEE Scale-up by Vestbee",
    maxWidth: 100,
  },
  {
    image: images.award8,
    title: "The Unilever Foundry - Top 50 UK startups",
    maxWidth: 100,
  },
];

export default AWARDS;
